import { Formik } from "formik";
import React, { useCallback, useState } from "react";
import { getAdvanceSearch } from "../../store/reducers/queryData";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import BasicSelect from "../BasicSelect";
import LoadButton from "../LoadButton";
import { jsonSort, teamUsers } from "../../utils/commonMethods";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setQuery } from "../../store/reducers/query";
import { meeting } from "../../utils/menuItems";
import dayjs from "dayjs";
import MultiSelect from "../MultiSelect";

const MeetingAdForm = ({ handleClose, users }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.auth);
  // const { users } = useSelector((state) => state.users);
  const { teams } = useSelector((state) => state.teams);
  const { query } = useSelector((state) => state.query);
  const agent = auth?.role === "agent";
  const teamLeadAgent = auth?.role === "team_lead" || auth?.role === "agent";
  const AMTeamLeadAgent = teamLeadAgent || auth?.role === "assistant_manager";
  const ManagerAMTeamLeadAgent = AMTeamLeadAgent || auth?.role === "manager";
  const SrmManagerAMTeamLeadAgent =
    ManagerAMTeamLeadAgent || auth?.role === "sr_manager";

  const [values, setValues] = useState({
    type: query?.type ? query?.type : "",
    status: query?.status ? query?.status : "",
    clientName: query?.clientName ? query?.clientName : "",
    code: query?.code ? query?.code : "",
    mobile: query?.mobile ? query?.mobile : "",
    clientEmail: query?.clientEmail ? query?.clientEmail : "",
    startDate: query?.startDate
      ? dayjs(query?.startDate).startOf("day")
      : dayjs(Date.now()).subtract(2, "days").startOf("day"),
    endDate: query?.startDate
      ? dayjs(query?.endDate).endOf("day")
      : dayjs(Date.now()).endOf("day"),
    srManager: query?.srManager ? query?.srManager : [],
    manager: query?.manager ? query?.manager : [],
    assistantManager: query?.assistantManager ?? [],
    teamLead: query?.teamLead ? query?.teamLead : [],
    agent: query?.agent ? query?.agent : [],
    exclude: {
      srManager: query?.exclude?.srManager ?? false,
      manager: query?.exclude?.manager ?? false,
      assistantManager: query?.exclude?.assistantManager ?? false,
      teamLead: query?.exclude?.teamLead ?? false,
      agent: query?.exclude?.agent ?? false,
    },
    teamOption: {
      srManager: query?.teamOption?.srManager ?? false,
      manager: query?.teamOption?.manager ?? false,
      assistantManager: query?.teamOption?.assistantManager ?? false,
      teamLead: query?.teamOption?.teamLead ?? false,
    },
    teamId: query?.teamId ? query?.teamId : undefined,
  });

  return (
    <Formik
      initialValues={values}
      onSubmit={async (values) => {
        if (values.code && values.mobile) {
          values = {
            ...values,
            clientMobile: `${values.code}-${values.mobile}`,
          };
        }
        setLoading(true);
        try {
          // const { type } = await dispatch(
          //   getAdvanceSearch({ apiEndpoint: Apis.filterMeetings, values })
          // );
          dispatch(setQuery({ values, type: "meeting" }));
          setLoading(false);
          // if (type === `lead/filterLeads/fulfilled`) {
          navigate(`/meetings`);
          //popup Close
          handleClose();
          // }
        } catch (err) {
          console.log("err", err);
        }
      }}
    >
      {({ values, handleChange, setFieldValue, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Grid container rowSpacing={3} columnSpacing={3} mt={0}>
            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Start Date
              </Typography>
              <DatePicker
                value={values.startDate}
                onChange={(newValue) => setFieldValue("startDate", newValue)}
                sx={{ width: "100%" }}
                placeholder="start"
                format="DD/MM/YYYY"
                slotProps={{
                  field: {
                    size: "small",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                End Date
              </Typography>
              <DatePicker
                value={values.endDate}
                onChange={(newValue) => setFieldValue("endDate", newValue)}
                sx={{ width: "100%" }}
                placeholder="start"
                format="DD/MM/YYYY"
                slotProps={{
                  field: {
                    size: "small",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Status
              </Typography>
              <BasicSelect
                value={values.status}
                name={"status"}
                size="small"
                handleChange={handleChange}
                items={meeting}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Client Name
              </Typography>
              <TextField
                name="clientName"
                value={values.clientName}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Client Email
              </Typography>
              <TextField
                name="clientEmail"
                value={values.clientEmail}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  Client Mobile
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Select
                    value={values.code}
                    onChange={handleChange}
                    size="small"
                    name="code"
                    sx={{ minWidth: "4rem" }}
                  >
                    <MenuItem value="1">+1 (USA)</MenuItem>
                    <MenuItem value="44">+44 (UK)</MenuItem>
                    <MenuItem value="91">+91 (IN)</MenuItem>
                    <MenuItem value="971">+971 (UAE)</MenuItem>
                    {/* Add more country codes as needed */}
                  </Select>
                  <TextField
                    label="Mobile Number"
                    name="mobile"
                    type="number"
                    value={values.mobile}
                    onChange={handleChange}
                    placeholder="Enter mobile number"
                    fullWidth
                    size="small"
                  />
                </Box>
              </>
            </Grid>

            {!SrmManagerAMTeamLeadAgent && (
              <Grid item xs={12} sm={6} md={4}>
                <Stack
                  direction="row"
                  spacing={5}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Sr Manager
                  </Typography>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="12px"
                          onChange={(e) =>
                            setFieldValue("teamOption", {
                              ...(values.teamOption || {}),
                              srManager: e.target.checked,
                            })
                          }
                          checked={values.teamOption.srManager}
                        />
                      }
                      label="Team"
                    />
                    {values.teamOption?.srManager && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="12px"
                            onChange={(e) =>
                              setFieldValue("exclude", {
                                ...(values.exclude || {}),
                                srManager: e.target.checked,
                              })
                            }
                            checked={values.exclude.srManager}
                          />
                        }
                        label="User Exclude"
                      />
                    )}
                  </div>
                </Stack>
                <MultiSelect
                  value={values.srManager}
                  name={"srManager"}
                  handleChange={setFieldValue}
                  items={users?.["sr_manager"]}
                />
              </Grid>
            )}

            {!ManagerAMTeamLeadAgent && (
              <Grid item xs={12} sm={6} md={4}>
                <Stack
                  direction="row"
                  spacing={5}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Team Manager
                  </Typography>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="12px"
                          onChange={(e) =>
                            setFieldValue("teamOption", {
                              ...(values.teamOption || {}),
                              manager: e.target.checked,
                            })
                          }
                          checked={values.teamOption.manager}
                        />
                      }
                      label="Team"
                    />
                    {values.teamOption?.manager && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="12px"
                            onChange={(e) =>
                              setFieldValue("exclude", {
                                ...(values.exclude || {}),
                                manager: e.target.checked,
                              })
                            }
                            checked={values.exclude.manager}
                          />
                        }
                        label="User Exclude"
                      />
                    )}
                  </div>
                </Stack>
                <MultiSelect
                  value={values.manager}
                  name={"manager"}
                  handleChange={setFieldValue}
                  items={users?.["manager"]}
                />
              </Grid>
            )}

            {!AMTeamLeadAgent && (
              <Grid item xs={12} sm={6} md={4}>
                <Stack
                  direction="row"
                  spacing={5}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Assistant Manager
                  </Typography>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="12px"
                          onChange={(e) =>
                            setFieldValue("teamOption", {
                              ...(values.teamOption || {}),
                              assistantManager: e.target.checked,
                            })
                          }
                          checked={values.teamOption.assistantManager}
                        />
                      }
                      label="Team"
                    />

                    {values.teamOption?.assistantManager && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="12px"
                            onChange={(e) =>
                              setFieldValue("exclude", {
                                ...(values.exclude || {}),
                                assistantManager: e.target.checked,
                              })
                            }
                            checked={values.exclude.assistantManager}
                          />
                        }
                        label="Exclude"
                      />
                    )}
                  </div>
                </Stack>
                <MultiSelect
                  value={values.assistantManager}
                  name={"assistantManager"}
                  handleChange={setFieldValue}
                  items={users?.["assistant_manager"]}
                />
              </Grid>
            )}

            {!teamLeadAgent && (
              <Grid item xs={12} sm={6} md={4}>
                <Stack
                  direction="row"
                  spacing={5}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Team Lead
                  </Typography>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="12px"
                          onChange={(e) =>
                            setFieldValue("teamOption", {
                              ...(values.teamOption || {}),
                              teamLead: e.target.checked,
                            })
                          }
                          checked={values.teamOption.teamLead}
                        />
                      }
                      label="Team"
                    />

                    {values.teamOption?.teamLead && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="12px"
                            onChange={(e) =>
                              setFieldValue("exclude", {
                                ...(values.exclude || {}),
                                teamLead: e.target.checked,
                              })
                            }
                            checked={values.exclude.teamLead}
                          />
                        }
                        label="Exclude"
                      />
                    )}
                  </div>
                </Stack>
                <MultiSelect
                  value={values.teamLead}
                  name={"teamLead"}
                  handleChange={setFieldValue}
                  items={users?.["team_lead"]}
                />
              </Grid>
            )}
            {!agent && (
              <Grid item xs={12} sm={6} md={4}>
                <Stack
                  direction="row"
                  spacing={5}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Agents
                  </Typography>
                </Stack>
                <MultiSelect
                  value={values.agent}
                  name={"agent"}
                  handleChange={setFieldValue}
                  items={users?.["agent"]}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <LoadButton
                loading={loading}
                type="submit"
                variant="contained"
                color="custom"
                sx={{ width: "120px", marginBottom: "15px" }}
              >
                Apply
              </LoadButton>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default MeetingAdForm;
